import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../component/Loader"

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();

  const handleLogin = (e) => {
    setLoading(true)
    e.preventDefault();
    fetch(`${process.env.REACT_APP_API_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 401) {
          alert("wrong email/password");
        } else {
          alert("Sorry we're having a server error");
        }
      })
      .then((data) => {
        console.log(data);
        localStorage.setItem("token", data?.accessToken);
        navigate("/");
      })
      .catch((err) => console.error(err))
      .finally(()=>setLoading(false))
  };

  return (
    <div className="login-container">
      <Loader loading={loading}/>
      <div className="login-card">
        <h1 className="login-title">Welcome Back</h1>
        <form onSubmit={handleLogin}>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
          />

          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />

          <button type="submit">Login</button>
        </form>
        <p className="signup-text">
          Don't have an account?{" "}
          <span onClick={() => navigate("/signup1")}>Sign Up</span>
        </p>
      </div>
    </div>
  );
}
